/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__ from "@agent-infra/logger";
import * as __WEBPACK_EXTERNAL_MODULE_duck_duck_scrape_55204f07__ from "duck-duck-scrape";
import * as __WEBPACK_EXTERNAL_MODULE_async_retry_b2da4330__ from "async-retry";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class DuckDuckGoSearchClient {
    async search(params) {
        this.logger.log('search params', params);
        try {
            const { query, count = 5, retry, ...restParams } = params;
            const result = await (0, __WEBPACK_EXTERNAL_MODULE_async_retry_b2da4330__["default"])(()=>__WEBPACK_EXTERNAL_MODULE_duck_duck_scrape_55204f07__.search(query, {
                    safeSearch: __WEBPACK_EXTERNAL_MODULE_duck_duck_scrape_55204f07__.SafeSearchType.STRICT,
                    ...restParams
                }), retry);
            console.log('result', result);
            return result ? {
                noResults: result.noResults,
                vqd: result.vqd,
                results: result.results.slice(0, count)
            } : {
                noResults: true,
                vqd: '',
                results: []
            };
        } catch (error) {
            this.logger.error('Error performing DuckDuckGo search:', error);
            throw error;
        }
    }
    constructor(config){
        _define_property(this, "logger", void 0);
        _define_property(this, "config", void 0);
        this.config = config;
        this.logger = (null == config ? void 0 : config.logger) ?? __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__.defaultLogger;
    }
}
export { DuckDuckGoSearchClient };

//# sourceMappingURL=api-client.mjs.map